import { keyframes } from 'styled-components'

const shake = keyframes`
  10%, 90% {
    transform: translateX(-1px,);
  }

  20%, 80% {
    transform: translateX(2px);
  }

  30%, 50%, 70% {
    transform: translateX(-3px);
  }

  40%, 60% {
    transform: translateX(3px);
  }
`

export default shake
